// Libs
import React, { useMemo } from 'react';
import { Typography } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useSelector } from 'react-redux';

// Components
import IconButton from '../../../components/Button/IconButton/IconButton';
import ReorderButton from '../../../components/Button/ReorderButton/ReorderButton';
import Feather from '../../../components/Feather';

// Hooks
import useKitActions from './useKitActions';
import useUser from '../../../hooks/useUser';

// Utils
import { getTotalQty } from '../utils/calculations';

// Selectors
import { productsObjSelector } from '../../../store/selectors';

// Styles
import { useStyles } from './useKitsCellsReducersStyles';

const useKitsCellsReducers = ({ kit }) => {
  const { onReorderClick, onDeleteClick, onViewDetailsClick, canReorder } =
    useKitActions(kit);
  const { isKiteUser } = useUser();
  const { classes } = useStyles();
  const productsObj = useSelector((state) => productsObjSelector(state));

  const cells = useMemo(
    () => ({
      kitNickname: (
        <Typography
          data-testid={'kit-name'}
          variant={isKiteUser ? 'textSm' : 'textSmSemibold'}
          className={classes.kitName}
          title={kit.name}>
          {kit.name}
        </Typography>
      ),
      totalQnty: getTotalQty(kit, productsObj),
      viewDetailsButton: (
        <IconButton
          data-testid={'kit-details-button'}
          onClick={() => onViewDetailsClick(kit.id)}
          endIcon={<ChevronRightIcon className={classes.chevron} />}
          className={classes.flatIconButton}>
          View Details
        </IconButton>
      ),
      reorderButton: (
        <ReorderButton
          disabled={!canReorder}
          kit={kit}
          onClick={onReorderClick}
          inTable={true}
        />
      ),
      deleteButton: (
        <Feather
          data-testid="kit-remove-button"
          type="close"
          colorType="grey2"
          className={classes.kitIcon}
          onClick={() => onDeleteClick(kit.id)}
        />
      ),
    }),
    [
      kit,
      onDeleteClick,
      onReorderClick,
      onViewDetailsClick,
      productsObj,
      canReorder,
      isKiteUser,
      classes,
    ],
  );

  return {
    cells,
  };
};

export default useKitsCellsReducers;
